import React from "react";
import _, { get } from "lodash";
import {CommonSubmitButton, LoaderType, RenderForm, showNotification, SwitchLoader} from "../../../common";
import { useHistory } from "react-router-dom";
import {ClubModel, UserModel} from "../../../model";
import {IState} from "../Data";
import {ClubService} from "../../../services";
import { CropImage } from "../modal/CropImage";

export const ClubForm = (props: IState) => {
  let history = useHistory();
  const [show, setShow] = React.useState(false);
  const [form, setForm] = React.useState({} as ClubModel);
  const [errors, setErrors] = React.useState<{[key: string]: string}>({});
  const [coachDirectors, setCoachDirectors] = React.useState([] as Array<UserModel>);
  const [psychologist, setPsychologist] = React.useState([] as Array<UserModel>);
  const [physiotherapist, setPhysiotherapist] = React.useState([] as Array<UserModel>);
  const [dofs, setDofs] = React.useState([] as Array<UserModel>);

  const handleChange = (event: React.ChangeEvent<HTMLElement>) => {
    const target: any = event.target;
    const value = target.type === 'file' 
      ? target.files[0] 
      : target.type === 'checkbox' 
        ? target.checked ? 1 : 0 
        : target.value;

    const name = target.name;

   if (name === "our_safety_url") {
      if (value) {
      const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
      if (!slugPattern.test(value)) {
        setErrors(prev => ({
          ...prev,
          [name]: "Please enter a valid slug."
        }));
      } else {
        setErrors(prev => ({ ...prev, [name]: "" }));
      }
      } else {
        setErrors(prev => ({ ...prev, [name]: "" })); // clear if empty
      }
    }


    setForm({ ...form, [name]: value });
    if (target.type === 'file') {
      setShow(true);
    }
  };
  React.useEffect(() => {
    setForm(props.club)
  },[props.club])

  React.useEffect(() => {
    async function init() {
      const users: any = await ClubService.coachDirectorsList({club_id: get(props, "club.id", null)});
      setCoachDirectors(users.coaches);
      setPsychologist(users.psychologist);
      setPhysiotherapist(users.physiotherapist);
      setDofs(users.dofs);
    }
    init()
  },[props.club])



  const FormInputs = [
    {
      "name" : "name",
      "value" : _.get(form, "name", ""),
      "onChange": handleChange,
      "required": true,
      "placeholder": "Enter club name",
      "label": "Club name",
    },
    {
      "name" : "our_safety_url",
      "value" : _.get(form, "our_safety_url", ""),
      "onChange": handleChange,
     // "required": true,
      "placeholder": "Enter ourSafety net slug",
      "label": "OurSafety Net Slug",
      "error": errors["our_safety_url"],
    },
    {
      "name" : "user_id",
      "value" : _.get(form, "user_id", ""),
      "onChange": handleChange,
      "required": true,
      "type": "select",
      "placeholder": "Select Coach Director",
      "label": "Club Coach Director",
      "options" : coachDirectors
    },
    {
      "name" : "psychologist_id",
      "value" : _.get(form, "psychologist_id", ""),
      "onChange": handleChange,
      //"required": true,
      "type": "select",
      "placeholder": "Select Psychologist",
      "label": "Club Psychologist",
      "options" : psychologist
    },
    {
      "name" : "physiotherapist_id",
      "value" : _.get(form, "physiotherapist_id", ""),
      "onChange": handleChange,
      //"required": true,
      "type": "select",
      "placeholder": "Select Physiotherapist",
      "label": "Club Physiotherapist",
      "options" : physiotherapist
    },
    {
      "name" : "dof_id",
      "value" : _.get(form, "dof_id", ""),
      "onChange": handleChange,
      //"required": true,
      "type": "select",
      "placeholder": "Select DOF",
      "label": "Club DOF",
      "options" : dofs
    },
    {
      "name" : "file",
      //"value" : _.get(form, "file.name", ""),
      "onChange": handleChange,
      "type": "file",
      "label": "Logo",
      "file_path":  _.get(form, "logo", "")
    }
  ];

  // if(_.isUndefined(props.club)){
  //   FormInputs.push({
  //     "name" : "start_date",
  //     "value" : _.get(form, "start_date", ""),
  //     "onChange": handleChange,
  //     "required": true,
  //     "type": "date",
  //     "placeholder": "Club Session Start Date",
  //     "label": "Club Session Start Date"
  //   } as any)
  //   FormInputs.push({
  //     "name" : "end_date",
  //     "value" : _.get(form, "end_date", ""),
  //     "onChange": handleChange,
  //     "required": true,
  //     "type": "date",
  //     "placeholder": "Club Session End Date",
  //     "label": "Club Session End Date"
  //   } as any)
  // }

  const ThemePermit = {
    "name" : "can_update_settings",
    "value" : _.get(form, "can_update_settings", 0),
    "onChange": handleChange,
    "type": 'checkbox',
    "label": "Allow update club theme",
    "style": {height: 20},
    "checked": _.get(form, "can_update_settings", 0) === 1
  };
  const CommunityPermit = {
    "name" : "allow_community",
    "value" : _.get(form, "allow_community", 0),
    "onChange": handleChange,
    "type": 'checkbox',
    "label": "Allow Community",
    "style": {height: 20},
    "checked": _.get(form, "allow_community", 0) === 1
  };
  const SsoLogin = {
    "name" : "is_sso_enabled",
    "value" : _.get(form, "is_sso_enabled", 0),
    "onChange": handleChange,
    "type": 'checkbox',
    "label": "Allow Sso Features",
    "style": {height: 20},
    "checked": _.get(form, "is_sso_enabled", 0) === 1
  };

  function isDisable() {
    return FormInputs.reduce(
      (acc, val) => acc ? acc : (val.value === "" || _.isNull(val.value)) && val.required, 
      false
    ) || Object.values(errors).some(err => err);
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    SwitchLoader(LoaderType.BUTTON);

    if(props.id){
      ClubService.updateClub(form, props.id).then((message) => {
        showNotification("success", message);
        history.push(`/clubs/clubs`)
      }).catch(() => {});
    } else {
      ClubService.storeClub(form).then((message) => {
        showNotification("success", message);
        history.push(`/clubs/clubs`)
      }).catch(() => {});
    }
  }

    return(
        <form className="kt-form" id={'customer_form'} onSubmit={handleSubmit}>
          <div className="kt-portlet__body">
            <div className={'row'}>
              <RenderForm items={FormInputs}/>
              <div className={"col-md-6 col-lg-6"}>
                <label className="kt-checkbox kt-checkbox--brand">
                  <input type="checkbox" {...ThemePermit}/> Enable to allow club to manage theme settings
                  <span></span>
                </label>
              </div>

              <div className={"col-md-6 col-lg-6"}>
                <label className="kt-checkbox kt-checkbox--brand">
                  <input type="checkbox" {...CommunityPermit}/> Enable to allow club to use comunity features
                  <span></span>
                </label>
              </div>
              <div className={"col-md-6 col-lg-6"}>
                <label className="kt-checkbox kt-checkbox--brand">
                  <input type="checkbox" {...SsoLogin}/> Enable to allow club to sso features
                  <span></span>
                </label>
              </div>
            </div>
          </div>
          <CommonSubmitButton disabled={isDisable()}/>
          <CropImage
            show={show}
            file={get(form, "file", "")}
            type={'logo'}
            closeModal={(file) => {
              setShow(false);
              setForm({...form, 'logo': file } as any)
            }}
          />
        </form>
      )
}